import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["baseLimit", "row"]

  connect() {
    this.update = this.update.bind(this)
  }

  update() {
    const limit = parseFloat(this.baseLimitTarget.value) || 0

    this.rowTargets.forEach(row => {
      const conversionRateField = row.querySelector('input[name*="[conversion_rate]"]')
      if (!conversionRateField) return

      const rate = parseFloat(conversionRateField.value) || 1
      const localLimitField = row.querySelector('input[name*="[hourly_match_amount]"]')

      if (localLimitField) localLimitField.value = (limit * rate).toFixed(2)
    })
  }

  enableCheckbox(event) {
    const row = event.target.closest('[data-volunteering-match-settings-target]')
    if (!row) return

    const checkbox = row.querySelector('input[type="checkbox"][name*="[active]"]')
    if (checkbox) checkbox.checked = true
  }
}
